import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { useSapToDm } from './hooks/useSapToDm';

export const SapToDm: React.FC<EmptyProps> = () => {
	const {
		data: { displayName, id },
		actions: { trackSapClick },
	} = useSapToDm();

	return (
		<div className="border-stroke-disabled space-y-6 rounded-xl border p-6 text-left">
			<Text as="h2" variant="heading" className="text-size-heading-xs md:text-size-heading-small">
				<Translate value="corgi.decision_maker_profile.sap_to_dm.heading" replacements={{ displayName }} />
			</Text>
			<div className="flex justify-start">
				<Button
					href={`/start-a-petition/intro?source_location=dm_profile_page&decision_maker_id=${id}`}
					as="a"
					variant="primary"
					className="whitespace-normal md:w-fit [&_*]:!text-[16px]"
					data-qa="dm-sap-cta-button"
					onClick={trackSapClick}
				>
					<Translate value="corgi.decision_maker_profile.sap_to_dm.cta_button" />
				</Button>
			</div>
		</div>
	);
};
